import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import ToastPortal from './toast-portal';
import { useSelector } from 'react-redux';
import { SuccessSmiley, ErrorSmiley, NotifySmiley } from './smileys';
import styles from './toast.module.scss';

export const Toast = ({ hideToast }) => {
  const toastData = useSelector((state) => state.toast);

  const { show, title, body, type, actionValue, actionFunction } = toastData;

  let smiley;

  if (type === 'error') {
    smiley = <ErrorSmiley />;
  } else if (type === 'success') {
    smiley = <SuccessSmiley />;
  } else {
    smiley = <NotifySmiley />;
  }

  return (
    <ToastPortal show={show} hideToast={hideToast}>
      <div className={styles.toast} data-testid='toast'>
        <div className={styles.toastContent}>
          {smiley}
          <div>
            <h5>{title}</h5>
            <p>{body}</p>
          </div>
        </div>
        {type === 'notify' ? (
          <div className={styles.toastButtons}>
            <button>Go there</button>
            <button onClick={hideToast}>Close</button>
          </div>
        ) : (
          <button onClick={actionFunction !== '' ? actionFunction : hideToast}>
            {actionValue !== '' ? actionValue : 'Close'}
          </button>
        )}
      </div>
    </ToastPortal>
  );
};
